import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * BackToCockpit — small kicker link that appears at the top of every profile
 * sub-page (Documents, PHF, Account Settings, Digital ID, etc.) so members can
 * always jump back to the Cockpit (their profile) with one tap.
 *
 * If browser history is deeper than 1, uses navigate(-1) so back nav from a
 * dashboard shortcut still works; otherwise falls back to /profile.
 */
export default function BackToCockpit({ label = "Back to Cockpit", testId = "back-to-cockpit" }) {
  const nav = useNavigate();
  const go = (e) => {
    if (window.history.length > 1) {
      e.preventDefault();
      nav(-1);
    }
  };
  return (
    <Link
      to="/dashboard"
      onClick={go}
      data-testid={testId}
      className="inline-flex items-center gap-1.5 mono text-[11px] tracking-widest text-cyan/80 hover:text-cyan mb-4"
    >
      <ArrowLeft className="h-3 w-3" /> {label.toUpperCase()}
    </Link>
  );
}
